import { useInitHeap } from 'util/heap.hooks';

const Heap = ({ children }) => {
  useInitHeap();

  return children;
};
export default Heap;
